module.exports = __webpack_public_path__ + "static/two-023a718e5154408277a81e2b9f60a2cb.png";